export default "__VITE_ASSET__DvlPyHzX__"